import { ViewHook } from "phoenix_live_view";
import { Tween, Easing } from "@tweenjs/tween.js";
import { pageLocale } from "../utils/formatters";

class AnimatedNumber extends ViewHook {
  private tween?: Tween;

  private value?: number;
  private duration?: number;
  private format?: string;

  mounted() {
    if (!this.el.dataset.value || !this.el.dataset.start || !this.el.dataset.duration) {
      console.error("AnimatedNumber: missing required data-attributes");
      return;
    }

    this.value = Math.trunc(Number(this.el.dataset.value));
    this.duration = Math.trunc(Number(this.el.dataset.duration));
    this.format = this.el.dataset.format;

    const start = Math.trunc(Number(this.el.dataset.start));

    this.animateNumber({ value: this.value, start });
  }

  updated() {
    const start = this.value!;

    this.value = Math.trunc(Number(this.el.dataset.value!));

    if (start === this.value) {
      this.el.textContent = this.formatValue(this.value);
    } else {
      this.animateNumber({ value: this.value, start });
    }
  }

  destroyed() {
    this.tween?.stop();
    this.tween = undefined;
  }

  private animateNumber({ value, start }: { value: number; start: number }) {
    this.tween?.stop();

    const object = { value: start };

    this.tween = new Tween(object)
      .to({ value }, this.duration)
      .easing(Easing.Quadratic.Out)
      .onUpdate(() => {
        this.el.textContent = this.formatValue(object.value);
      })
      .start();

    const animate = (time: number) => {
      this.tween?.update(time);
      requestAnimationFrame(animate);
    };

    requestAnimationFrame(animate);
  }

  // Opt-in via `data-format="comma"` to render thousands separators (e.g. 12,340).
  private formatValue(n: number): string {
    const rounded = Math.round(n);

    return this.format === "comma" ? rounded.toLocaleString(pageLocale()) : rounded.toString();
  }
}

export default AnimatedNumber;
